import { Component, OnInit } from "@angular/core";
import { MediaViewsService } from "../../services/media-views.service";
import { ControlService } from "../../services/control.service";

// NUEVO: servicios para unidades y clientes
import { UnitssService } from "../../services/unitss.service";
import { CustomersService } from "../../services/customers.service";
import { Router } from "@angular/router";

@Component({
	selector: "app-dashboard",
	templateUrl: "./dashboard.component.html",
	styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
	isAdmin = false;

	// EXISTENTE
	diasSeleccionados = 7;
	barChartClienteLabels: string[] = [];
	barChartClienteData: any[] = [];
	barChartMediaLabels: string[] = [];
	barChartMediaData: any[] = [];
	lineChartLabels: string[] = [];
	lineChartData: any[] = [];
	barChartGrupoLabels: string[] = [];
	barChartGrupoData: any[] = [];
	barChartReelLabels: string[] = [];
	barChartReelData: any[] = [];
	barChartMediaDeReelLabels: string[] = [];
	barChartMediaDeReelData: any[] = [];
	selectedGroupId: number | null = null;
	selectedGroupName: string | null = null;
	selectedReelId: number | null = null;
	selectedReelName: string | null = null;
	barChartType = "bar";
	clientes: Array<{ id: number; nombre: string }> = [];
	selectedClientId: number | null = null;

	sortField: string = "";
	sortDirection: "asc" | "desc" = "asc";

	barChartLegend = false;
	barChartOptions: any = {
		responsive: true,
		maintainAspectRatio: false,
		legend: { display: false },
		scales: {
			xAxes: [{ display: true }],
			yAxes: [
				{
					display: true,
					ticks: { beginAtZero: true, precision: 0 },
				},
			],
		},
	};
	barChartOptionsClickable: any = {
		responsive: true,
		maintainAspectRatio: false,
		legend: { display: false },
		scales: {
			xAxes: [{ display: true }],
			yAxes: [
				{
					display: true,
					ticks: { beginAtZero: true, precision: 0 },
				},
			],
		},
	};
	barChartColours = [{ backgroundColor: "#3b82f6", borderWidth: 0 }];

	lineChartOptions: any = {
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			xAxes: [{ display: true }],
			yAxes: [
				{ display: true, ticks: { beginAtZero: true, precision: 0 } },
			],
		},
	};

	// NUEVO: apartado de Unidades Conectadas
	connectedUnits: Array<{
		id: number;
		name: string;
		client_id: number | null;
		description?: string;
		raspberry_number?: string;
		last_connection?: string | null;
		lastEvidence?: { date?: string; path?: string } | null;
		last_seen?: string | null;
		is_connected: number; // 1 ó 0
		bw?: number | null;
	}> = [];

	// ventanas de tiempo configurables (coinciden con la API propuesta)
	connMinutes = 20; // ventana para last_connection (min)
	evHours = 6; // ventana para lastEvidence (horas)

	// mapa de clientes para mostrar nombre en la tabla (opcional)
	private clientesMap = new Map<number, string>();

	constructor(
		private controlService: ControlService,
		private mediaViewsService: MediaViewsService,

		// NUEVO: inyectar servicios
		private unitssService: UnitssService,
		private customersService: CustomersService,

		private router: Router
	) {}

	sortBy(field: string, type: "text" | "number" | "date" = "text") {
		if (this.sortField === field) {
			// Cambiar dirección si es la misma columna
			this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
		} else {
			this.sortField = field;
			this.sortDirection = "asc";
		}

		this.connectedUnits.sort((a, b) => {
			let aValue = a[field];
			let bValue = b[field];

			// Convertir valores según tipo
			switch (type) {
				case "number":
					aValue = Number(aValue) || 0;
					bValue = Number(bValue) || 0;
					return this.sortDirection === "asc"
						? aValue - bValue
						: bValue - aValue;
				case "date":
					aValue = aValue ? new Date(aValue).getTime() : 0;
					bValue = bValue ? new Date(bValue).getTime() : 0;
					return this.sortDirection === "asc"
						? aValue - bValue
						: bValue - aValue;
				default:
					return this.sortDirection === "asc"
						? aValue
								.toString()
								.localeCompare(bValue.toString(), "es", {
									sensitivity: "base",
								})
						: bValue
								.toString()
								.localeCompare(aValue.toString(), "es", {
									sensitivity: "base",
								});
			}
		});
	}

	ngOnInit(): void {
		this.controlService.isAdmin().subscribe((res) => {
			this.isAdmin = res.is_admin;
			if (!this.isAdmin) {
				this.router.navigate(["/admin/svs/media"]);
			}

			// Cargar métricas existentes
			this.cargarMetricas();

			// NUEVO: cargar conectadas
			this.cargarUnidadesConectadas();

			// NUEVO: si quieres ver el nombre del cliente en la tabla, cargamos clientes
			this.cargarClientesParaMapa();
		});
	}

	private cargarClientesParaMapa(): void {
		this.customersService.datatable(1, {}).subscribe((res: any) => {
			const data = res?.data || [];

			// para el select
			this.clientes = data.map((c: any) => ({
				id: c.id,
				nombre: c.nombre_comercial ?? c.name ?? `Cliente ${c.id}`,
			}));

			// para lookup rápido por id (si lo usas en la tabla)
			this.clientesMap.clear();
			data.forEach((c: any) => {
				const nombre =
					c.nombre_comercial ?? c.name ?? `Cliente ${c.id}`;
				this.clientesMap.set(c.id, nombre);
			});
		});
	}

	onClienteChange(): void {
		// tabla conectadas
		this.cargarUnidadesConectadas();

		// si hay cliente seleccionado → mostrar “vista cliente” (métricas de cliente)
		if (this.selectedClientId) {
			this.cargarMetricasCliente(this.selectedClientId);
		} else {
			// si quitas el filtro, regresa a métricas admin globales
			this.cargarMetricasAdmin();
		}
	}

	// NUEVO: llamada a API /api/units/connected
	cargarUnidadesConectadas(): void {
		const params: any = {
			minutes: this.connMinutes,
			hours: this.evHours,
			only: 1,
		};

		if (this.isAdmin && this.selectedClientId) {
			this.cargarMetricasCliente(this.selectedClientId);
		} else if (this.isAdmin) {
			this.cargarMetricasAdmin();
		} else {
			this.cargarMetricasCliente();
		}

		this.unitssService.getConnectedUnits(params).subscribe({
			next: (res) => {
				const list = res?.data || [];
				this.connectedUnits = list
					.sort(
						(a: any, b: any) =>
							b.is_connected - a.is_connected ||
							new Date(b.last_seen || 0).getTime() -
								new Date(a.last_seen || 0).getTime()
					)
					.map((u: any) => ({
						...u,
						client_name: u.client_id
							? this.clientesMap.get(u.client_id) ||
							  "Cliente no asociado"
							: "Cliente no asociado",
					}));
			},
			error: () => (this.connectedUnits = []),
		});
	}

	cargarMetricas(): void {
		if (this.isAdmin) {
			this.cargarMetricasAdmin(this.selectedClientId ?? null);
		} else {
			this.cargarMetricasCliente();
		}
	}

	private cargarMetricasAdmin(clientId?: number | null): void {
		const params: any = { days: this.diasSeleccionados };
		if (clientId) params.client_id = clientId;

		// Totales por cliente
		this.mediaViewsService
			.getSummaryByClient(params)
			.subscribe((res: any[]) => {
				this.barChartClienteLabels = res.map((c) => c.nombre);
				this.barChartClienteData = [
					{
						data: res.map((c) => Number(c.total_vistas)),
						label: "Reproducciones Totales",
					},
				];
			});

		// Reproducciones por publicidad (global o filtrado por cliente)
		this.mediaViewsService
			.getSummaryByMedia(params)
			.subscribe((res: any[]) => {
				this.barChartMediaLabels = res.map((m) => m.nombre);
				this.barChartMediaData = [
					{
						data: res.map((m) => Number(m.total)),
						label: "Vistas por publicidad",
					},
				];
			});
	}

	cargarMetricasCliente(clientId?: number | null): void {
		const paramsBase: any = { days: this.diasSeleccionados };
		if (clientId) paramsBase.client_id = clientId;

		this.mediaViewsService
			.getSummaryByDateAndClient(paramsBase)
			.subscribe((res: any[]) => {
				this.lineChartLabels = res.map((r) => r.fecha);
				this.lineChartData = [
					{
						data: res.map((r) => Number(r.total)),
						label: "Reproducciones por Día",
					},
				];
			});

		this.mediaViewsService
			.getSummaryByGroup(paramsBase)
			.subscribe((res: any[]) => {
				this.barChartGrupoLabels = res.map((g) => g.group_name);
				this.barChartGrupoData = [
					{
						data: res.map((g) => Number(g.total_views)),
						label: "Vistas por Grupo",
					},
				];

				this.selectedGroupId = null;
				this.selectedGroupName = null;
				this.selectedReelId = null;
				this.selectedReelName = null;
				this.barChartReelLabels = [];
				this.barChartReelData = [];
				this.barChartMediaDeReelLabels = [];
				this.barChartMediaDeReelData = [];
			});
	}
	onGrupoChartClick(event: any): void {
		const idx = this.getClickedBarIndex(event);
		if (idx == null) return;

		const groupName = this.barChartGrupoLabels[idx];
		this.selectedGroupName = groupName;

		const paramsGroup: any = { days: this.diasSeleccionados };
		if (this.isAdmin && this.selectedClientId)
			paramsGroup.client_id = this.selectedClientId;

		this.mediaViewsService
			.getSummaryByGroup(paramsGroup)
			.subscribe((res: any[]) => {
				if (!res || !res[idx]) return;
				const groupId = Number(res[idx].group_id);
				this.selectedGroupId = groupId;

				const paramsReels: any = {
					groupId,
					days: this.diasSeleccionados,
				};
				if (this.isAdmin && this.selectedClientId)
					paramsReels.client_id = this.selectedClientId;

				this.mediaViewsService
					.getSummaryByReel(paramsReels)
					.subscribe((reels: any[]) => {
						this.barChartReelLabels = reels.map((r) => r.reel_name);
						this.barChartReelData = [
							{
								data: reels.map((r) => Number(r.total_views)),
								label: "Vistas por Reel",
							},
						];

						this.selectedReelId = null;
						this.selectedReelName = null;
						this.barChartMediaDeReelLabels = [];
						this.barChartMediaDeReelData = [];
					});
			});
	}

	onReelChartClick(event: any): void {
		const idx = this.getClickedBarIndex(event);
		if (idx == null) return;

		const reelName = this.barChartReelLabels[idx];
		this.selectedReelName = reelName;

		if (!this.selectedGroupId) return;

		const paramsReels: any = {
			groupId: this.selectedGroupId,
			days: this.diasSeleccionados,
		};
		if (this.isAdmin && this.selectedClientId)
			paramsReels.client_id = this.selectedClientId;

		this.mediaViewsService
			.getSummaryByReel(paramsReels)
			.subscribe((reels: any[]) => {
				if (!reels || !reels[idx]) return;
				const reelId = Number(reels[idx].reel_id);
				this.selectedReelId = reelId;

				const paramsMedia: any = {
					reelId,
					days: this.diasSeleccionados,
				};
				if (this.isAdmin && this.selectedClientId)
					paramsMedia.client_id = this.selectedClientId;

				this.mediaViewsService
					.getSummaryByMediaOfReel(paramsMedia)
					.subscribe((medias: any[]) => {
						this.barChartMediaDeReelLabels = medias.map(
							(m) => m.media_name
						);
						this.barChartMediaDeReelData = [
							{
								data: medias.map((m) => Number(m.total_views)),
								label: "Vistas por Media",
							},
						];
					});
			});
	}

	limpiarReel(): void {
		this.selectedReelId = null;
		this.selectedReelName = null;
		this.barChartMediaDeReelLabels = [];
		this.barChartMediaDeReelData = [];
	}

	private getClickedBarIndex(event: any): number | null {
		if (!event) return null;
		const active = event.active || [];
		if (active.length > 0) {
			const i2 = active[0]._index;
			if (typeof i2 === "number") return i2;
			const i3 = active[0].index;
			if (typeof i3 === "number") return i3;
		}
		return null;
	}

	formatDateTime(dateTime: string | null): string {
		if (!dateTime) return "-";

		const dateObj = new Date(dateTime);

		if (isNaN(dateObj.getTime())) {
			return "-"; // por si viene inválida
		}

		const date = dateObj.toLocaleDateString("es-MX", {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
		});

		const time = dateObj.toLocaleTimeString("es-MX", {
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
		});

		return `${date} ${time}`;
	}
}
